/* ----------------------------------------------------
   Manik Chand Jewellers – Live Gold Rate Widget Script
   Fetches live gold rates from Google Apps Script +
   displays the visitor's current local time (once).
----------------------------------------------------- */
(function(){
  if(window._goldRateLoaded) return;
  window._goldRateLoaded = true;

  // Google Apps Script endpoint
  var ENDPOINT = "https://script.google.com/macros/s/AKfycbw5dUFD0hQ8__PxLx2n-wk0lpdroSLbnulN_Ac8TyiuE8yakfzvtiWUQYuhRKq96aCtlw/exec";

  // Format number as ₹ per gram
  function formatINR(n){
    if(n === null || n === undefined || n === "") return '—';
    var num = Number(n);
    if(isNaN(num)) return n;
    var rounded = Math.round(num);
    return '₹ ' + rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + '/g';
  }

  // Display user's current local date/time (once)
  function showCurrentTime(){
    var el = document.getElementById('gold-updated');
    if(!el) return;
    var now = new Date();
    var options = { 
      weekday: 'short', year: 'numeric', month: 'short', day: 'numeric', 
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    };
    el.textContent = now.toLocaleString('en-IN', options);
  }

  // Populate gold rates + show time
  function setPrices(data){
    try {
      var root = document.getElementById('gold-rate-card');
      if(!root) return;

      // Set rates
      document.querySelectorAll('#gold-rate-card .price').forEach(function(el){
        var k = el.getAttribute('data-rate');
        if(k==='22') el.textContent = formatINR(data.rates["22"]);
        if(k==='18') el.textContent = formatINR(data.rates["18"]);
      });

      // Show time once (when loaded)
      showCurrentTime();

    } catch(e){
      console.error('GoldRate setPrices error', e);
    }
  }

  // JSONP callback from Google Script
  window.receiveGoldRates = function(data){ setPrices(data); };

  // Inject JSONP script
  function loadJsonp(){
    var s = document.createElement('script');
    s.async = true;
    s.src = ENDPOINT + (ENDPOINT.indexOf('?') === -1 ? '?' : '&') + 'callback=receiveGoldRates&nocache=' + Date.now();
    s.onerror = function(){ console.warn('Gold-rate JSONP failed to load'); };
    document.head.appendChild(s);
  }

  // Load when DOM ready
  if(document.readyState === 'complete' || document.readyState === 'interactive'){
    loadJsonp();
  } else {
    document.addEventListener('DOMContentLoaded', loadJsonp);
  }

})();
